import React, { PureComponent } from "react";
import ReactMarkdown from "react-markdown";
import { Mutation } from "react-apollo";
import gql from "graphql-tag";
import classNames from "classnames";

import customRendererLink from "../../utils/custom-link-renderer";
import VoteButtons from "../vote-buttons/vote-buttons";
import TickButton from "../tick-button/tick-button";
import PostDetails from "../post-details/post-details";

import QUESTION_QUERY from "../../queries/question-query";

import "./community-answer.scss";

const MARK_CORRECT_ANSWER_MUTATION = gql`
  mutation MARK_CORRECT_ANSWER_MUTATION($answerId: ID!, $questionId: ID!) {
    markCorrectAnswer(answerId: $answerId, questionId: $questionId) {
      success
    }
  }
`;

class CommunityAnswer extends PureComponent {
  markCorrectAnswer = (submit) => {
    if (!this.props.markingOfCorrectAnswerBlocked) {
      this.props.markedCorrectAnswer(this.props.id);
      submit();
    }
  };
  onMarkCorrectAnswerResponse = () => {
    this.props.toggleBlockOfMarkingCorrectAnswers(false);
  };
  render() {
    const {
      body,
      me,
      ratedUpKnowledgeItems,
      ratedDownKnowledgeItems,
      poster,
      createdAt,
      questionId,
      id,
      correctAnswerId,
      pageSlug,
      toggleOverlay,
      isOwnerOfQuestion,
    } = this.props;

    const isCorrectAnswer = correctAnswerId === id;

    return (
      <Mutation
        mutation={MARK_CORRECT_ANSWER_MUTATION}
        variables={{
          answerId: id,
          questionId,
        }}
        onCompleted={this.onMarkCorrectAnswerResponse}
        refetchQueries={[
          {
            query: QUESTION_QUERY,
            variables: { slug: pageSlug },
          },
        ]}
      >
        {(submit, { error, loading, called }) => {
          return (
            <div
              className={classNames("community-answer", {
                "community-answer--correct": isCorrectAnswer,
              })}
            >
              <div className="community-answer__inner">
                {isCorrectAnswer && (
                  <div className="community-answer__correct">
                    Marked as best answer
                  </div>
                )}
                <div className="community-answer__tick-button">
                  {isOwnerOfQuestion && (
                    <TickButton
                      toggleCorrectAnswer={() => this.markCorrectAnswer(submit)}
                      markedCorrect={isCorrectAnswer}
                      disabled={loading}
                    />
                  )}
                </div>
                <div className="community-answer__rating">
                  <VoteButtons
                    ratedUpKnowledgeItems={ratedUpKnowledgeItems}
                    ratedDownKnowledgeItems={ratedDownKnowledgeItems}
                    myId={me ? me.id : null}
                    voteOnWhat="ANSWER"
                    referenceId={id}
                    posterId={poster.id}
                    refetchQueryName="QUESTION_QUERY"
                    toggleOverlay={toggleOverlay}
                    refetchQueryVariables={{
                      slug: pageSlug,
                    }}
                    disabled={me && me.id === poster.id}
                  />
                </div>
                <div className="community-answer__body">
                  <ReactMarkdown
                    source={body}
                    escapeHtml={false}
                    linkTarget="_blank"
                    renderers={customRendererLink}
                  />
                  <PostDetails
                    me={me}
                    poster={poster}
                    type="ANSWER"
                    createdAt={createdAt}
                    itemId={id}
                  />
                </div>
              </div>
            </div>
          );
        }}
      </Mutation>
    );
  }
}

export default CommunityAnswer;
